import { useEffect, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { toast } from "sonner";

export default function AdminUnassignedImages() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/images/unassigned").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const assign = async (id) => {
    const sku = window.prompt("SKU tujuan (contoh: TS-001):");
    if (!sku) return;
    const role = window.prompt("Role (front / back / gallery)?", "gallery");
    if (!role) return;
    try { await api.post(`/admin/images/unassigned/${id}/assign`, { sku, role }); toast.success(`Ditugaskan ke ${sku.toUpperCase()} (${role})`); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };
  const del = async (id) => {
    if (!window.confirm("Hapus gambar unassigned ini?")) return;
    try { await api.delete(`/admin/images/unassigned/${id}`); toast.success("Dihapus"); load(); }
    catch (e) { toast.error("Gagal"); }
  };

  return (
    <div>
      <h1 className="display text-4xl md:text-6xl mb-6">UNASSIGNED IMAGES</h1>
      <p className="text-neutral-400 text-sm mb-4">Gambar yang tidak berhasil dicocokkan otomatis ke SKU (SKU tidak ditemukan atau nama file tidak mengandung SKU). Sistem tidak akan menebak — tugaskan manual di sini.</p>
      {items.length === 0 && <div className="text-neutral-500 text-sm border border-[color:var(--border)] p-6">Tidak ada gambar unassigned. 🎯</div>}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((it) => (
          <div key={it.id} className="border border-[color:var(--border)]">
            <img src={imgUrl(it.storage_path)} alt="" className="w-full aspect-square object-cover" />
            <div className="p-3 text-xs space-y-1">
              <div className="mono truncate">{it.original_filename}</div>
              <div className="text-neutral-500">{it.reason}</div>
              {it.detected_sku && <div className="text-amber-400">Detected: {it.detected_sku} ({it.detected_role || "gallery"})</div>}
              <div className="flex gap-2 pt-2">
                <button onClick={() => assign(it.id)} className="underline">Assign</button>
                <button onClick={() => del(it.id)} className="underline text-[color:var(--accent)]">Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
